import assetPath from '/app/packages/lebenslauf/articles/src/assets/der-umfassende-leitfaden-zum-telefoninterview-was-du-wissen-musst.jpg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')